import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/softwareDev/SoftwareDevPageClient.jsx");
